"use client"

import React from "react"
import { FragmentType, graphql, useFragment } from "@/gql"
import {
  AvatarWithNameAndTitleContent,
  AvatarWithNameAndTitleSize,
  AvatarWithNameAndTitleSizeVariant,
} from "./AvatarWithNameTitleContent"
import { it } from "node:test"
import { useRouter } from "next-nprogress-bar"
import clsx from "clsx"

const ClientAvatarWithNameAndTitleFragment = graphql(`
  fragment ClientAvatarWithNameAndTitle on IndividualClient {
    id
    jobTitle
    company
    handle
    user {
      id
      name
      ...AvatarWithNameAndTitleContent
    }
  }
`)

interface Props {
  client: FragmentType<typeof ClientAvatarWithNameAndTitleFragment> | null | undefined
  size: AvatarWithNameAndTitleSize
  variant: AvatarWithNameAndTitleSizeVariant
  className?: string
  canClick?: boolean
  titleMaxLines?: number
  subtitleMaxLines?: number
  redacted?: boolean
}

/*
 * This component should be used if you're only ever going to display a client's name and title.
 * use the User version if it's possible that the user could be a creative
 */
export const ClientAvatarWithNameAndTitle: React.FC<Props> = props => {
  const { size, variant, className, canClick = true } = props
  const router = useRouter()
  const client = useFragment(ClientAvatarWithNameAndTitleFragment, props.client)
  const user = client?.user
  const title = user?.name!
  const subtitle = client?.jobTitle && client?.company ? `${client?.jobTitle} at ${client?.company}` : client?.jobTitle

  return (
    <div
      className={clsx(canClick && "cursor-pointer")}
      onClick={e => {
        if (canClick) {
          e.preventDefault()
          e.stopPropagation()
          router.push(`/clients/${client?.handle}`)
        }
      }}>
      <AvatarWithNameAndTitleContent
        title={title}
        subtitle={subtitle}
        className={className}
        variant={variant}
        size={size}
        user={user}
        subtitleMaxLines={props.subtitleMaxLines}
        titleMaxLines={props.titleMaxLines}
        redacted={props.redacted}
      />
    </div>
  )
}
